import "@/style/memberDetail.scss"
import "@/style/inConstruction.scss"
import "@/utils/nav"
import "@/utils/tab.js"
import "@/utils/website.js"
import "@/utils/member-list.js"

const develop = "/api" 
let nav = $("#info-nav")

function get(par) {
    // 接收window.location.href中文参数用需要decodeURI解码
    const local_url = decodeURI(document.location.href)
    // 截取get字符串
    const getstr = local_url.substr(local_url.indexOf('?') + 1)
    // 解析成get数组
    const get = getstr.split('&')
    // 查找要找到参数
    for (var i in get) {
        if (get[i].indexOf(par + '=') >= 0) {
            return get[i].replace(par + '=', '')
        }
    }
    return false
}
const id = get('id')
const bg = get('bg')
const title = get('title')
$('.information-us').append(title)
let bgList = `<img class="bg-img" src= ${bg} />`
$('#bg-box').html(bgList)

$.get(develop+"/admin/official/exc/information/detail/" + id, function (data) {
    const title = data.data.title
    const num = data.data.num
    const detail = data.data.details
    const createTime = data.data.publicTime.substring(0,  10)
    $(".information-title").append(title)
    $("#time").append(createTime)
    $(".num").append(num)
    $(".policy-detail").append(detail)
})

nav.append(get("nav") + '>')

// 获取nav板块参数跳转相应页面
// $(document).ready(function () {
//     nav.click(function () {
//         const text = nav.text()
//         if (text === "党建引领>") {
//             window.location.href = '/indexList.html?idx=4'
//         } 
//     })
// })
